<script lang="ts">
  import type { FeatureRequest } from '../../lib/types';
  import FeatureRequestList from './FeatureRequestList.svelte';
  import FeatureRequestDetail from './FeatureRequestDetail.svelte';
  import CreateFeatureRequestModal from './CreateFeatureRequestModal.svelte';

  // View state
  type ViewState = 'list' | 'detail';
  let viewState = $state<ViewState>('list');
  let selectedRequest = $state<FeatureRequest | null>(null);
  let showCreateModal = $state(false);

  function handleSelectRequest(request: FeatureRequest) {
    selectedRequest = request;
    viewState = 'detail';
  }

  function handleBackToList() {
    viewState = 'list';
    selectedRequest = null;
  }

  function handleCreateSuccess() {
    // Refresh happens automatically via real-time listener
  }
</script>

<div class="features-container">
  {#if viewState === 'list'}
    <div class="features-header">
      <div class="header-content">
        <h2>Feature Requests</h2>
        <p>Vote on features you'd like to see, or submit your own ideas.</p>
      </div>
      <button class="submit-btn" onclick={() => showCreateModal = true}>
        <svg viewBox="0 0 20 20" fill="currentColor">
          <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
        </svg>
        Submit Request
      </button>
    </div>
    <FeatureRequestList onSelectRequest={handleSelectRequest} />
  {:else if viewState === 'detail' && selectedRequest}
    <FeatureRequestDetail request={selectedRequest} onBack={handleBackToList} />
  {/if}
</div>

{#if showCreateModal}
  <CreateFeatureRequestModal
    onClose={() => showCreateModal = false}
    onSuccess={handleCreateSuccess}
  />
{/if}

<style>
  .features-container {
    max-width: 900px;
  }

  .features-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    color: white;
  }

  .header-content h2 {
    margin: 0 0 0.25rem;
    font-size: 1.5rem;
  }

  .header-content p {
    margin: 0;
    opacity: 0.9;
    font-size: 0.9rem;
  }

  .submit-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 8px;
    color: white;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
  }

  .submit-btn:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  .submit-btn svg {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 640px) {
    .features-header {
      flex-direction: column;
      align-items: stretch;
    }

    .submit-btn {
      justify-content: center;
    }
  }
</style>
